import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { Bar } from 'react-chartjs-2';
import { Chart, registerables } from 'chart.js';
import '../styles/UsageReport.css';
import '../App.css';

var activeFilter = null;

function getNumEventsByUsername(events, eventType, uniqueDetails = false) {
    // console.log(events)
    var numEvents = {}
    var seen = []

    for (const event of events) {
        if (event[2] != eventType || "jmaring,avalentine,kjudd,jgardner".includes(event[1])) {
            continue
        }

        if (uniqueDetails && seen.includes(event[3].toLowerCase())) {
            // console.log("skipped")
            continue
        }

        seen.push(event[3].toLowerCase())

        var username = event[1]

        if (!(username in numEvents)) {
            numEvents[username] = 0
        }

        numEvents[username] += 1
    }

    var labels = []
    var data = []

    Object.entries(numEvents).forEach(([key, value]) => {
        labels.push(key)
    });

    labels.sort()
    // console.log(numEvents)

    for (var label of labels) {
        data.push(numEvents[label])
    }

    var res = {
        labels: labels,
        datasets: [
            {
                label: "'" + eventType + "' Events By User",
                backgroundColor: ["red", "green", "blue", "orange", "yelow", "purple", "silver", "brown"],
                borderWidth: 2,
                data: data,
            },
        ],
    };

    return res
}

function filterEvents(data) {
    const start = data.startDate.split("-").map((key) => parseInt(key))
    const end = data.endDate.split("-").map((key) => parseInt(key))
    const events = data.events

    // console.log(start, end)
    var res = []
    const keyConv = {
        "ID": 0,
        "Username": 1,
        "Type": 2,
        "Details": 3,
        "Time": 4,
    }

    for (var event of events) {
        var date = event[4].split(" ")[0].split("-").map((key) => parseInt(key))

        if (date[0] > end[0] || date[0] == end[0] && date[1] > end[1] || date[0] == end[0] && date[1] == end[1] && date[2] > end[2]) {
            // console.log(date)
            continue
        }

        if (date[0] < start[0] || date[0] == start[0] && date[1] < start[1] || date[0] == start[0] && date[1] == start[1] && date[2] < start[2]) {
            continue
        }

        if (!data.filters) {
            res.push(event)
        } else {
            var flag = true

            for (const [key, target] of Object.entries(data.filters)) {
                var index = keyConv[key]

                if (!event[index].toLowerCase().includes(target.toLowerCase()) && !target.toLowerCase().includes(event[index].toLowerCase()) && target != "") {
                    flag = false
                }
            }

            if (flag) {
                res.push(event)
            }
        }
    }

    // console.log(res)
    return res
}

function adjustFilters(event, header, setData, data) {
    if (event.key != "Enter") {
        return
    }

    const newFilter = document.getElementById(header + "Input").value

    try {
        data.filters[header] = newFilter
    } catch {
        data.filters = {}
        data.filters[header] = newFilter
    }
    setData(Object.assign({}, data))
}

function showFilterBox(colID) {
    const colDiv = document.getElementById(colID)

    if (activeFilter) {
        activeFilter.style.display = "none";
    }

    if (activeFilter != colDiv) {
        colDiv.style.display = ""
        activeFilter = colDiv
    } else {
        activeFilter = null;
    }
}

function setActiveData(data, newData, setData) {
    data.activeDataType = newData.datasets[0].label
    data.activeData = newData
    // console.log(data)
    setData(Object.assign({}, data))
}

function UsageReport(args) {
    const currentAuthKey = document.cookie.split("; ").find((row) => row.startsWith("authKey="))?.split("=")[1]
    const navigate = useNavigate()
    const requestManager = args.requestManager

    useEffect(() => {
        if (typeof currentAuthKey === "undefined") {
            navigate("/login")
        } else if (typeof data.keyError !== "undefined") {
            if (data.keyError === "notAuthorized") {
                navigate("/")
            } else {
                navigate("/login")
            }
        }
    })

    const [data, setData] = useState([{}])

    if (!(typeof data.status === "undefined")) {
        if (data.startDate == null) {
            data.startDate = "2024-07-01"
            data.endDate = new Date().toISOString().split("T")[0]
        }

        var events = filterEvents(data)
    } else {
        requestManager.request("usageReport", "POST").then(res => res.json()).then((response) => {
            setData(Object.assign({}, response))
        })
    }
    // console.log("render")

    const loginData = (!(typeof data.status === "undefined")) ? getNumEventsByUsername(events, "Login") : null
    const companyViewData = (!(typeof data.status === "undefined")) ? getNumEventsByUsername(events, "Company Viewed") : null
    const personViewData = (!(typeof data.status === "undefined")) ? getNumEventsByUsername(events, "Person Viewed") : null
    const lookupData = (!(typeof data.status === "undefined")) ? getNumEventsByUsername(events, "User Lookup", true) : null
    const emailData = (!(typeof data.status === "undefined")) ? getNumEventsByUsername(events, "Email Generated") : null
    var activeData = loginData

    for (var chartData of [loginData, companyViewData, personViewData, lookupData, emailData]) {
        // console.log("chart", chartData)
        if (chartData != null && chartData.datasets[0].label == data.activeDataType) {
            activeData = chartData
        }
    }

    Chart.register(...registerables);
    // console.log(activeData)
    return (
        <div class="container">
            <div class="pt-5 pb-3 text-center">
                {
                    (typeof data.status === "undefined") ?
                        (<h1 class="loading">Loading</h1>) :
                        (
                            <>
                                <h1 class="display-5 fw-bold">Event Logs</h1>
                                <div class="pb-2">
                                    <label for="start">Start:</label>
                                    <input onChange={() => { data.startDate = document.getElementById("start").value; setData(Object.assign({}, data)); }} class="ms-1 datePicker" type="date" id="start" name="start" defaultValue="2024-07-01" min="2023-12-01" max={new Date().toISOString().split("T")[0]} />
                                </div>
                                <div>
                                    <label for="end">End:</label>
                                    <input onChange={() => { data.endDate = document.getElementById("end").value; setData(Object.assign({}, data)); }} class="ms-1 datePicker" type="date" id="end" name="end" defaultValue={new Date().toISOString().split("T")[0]} min="2023-12-01" max={new Date().toISOString().split("T")[0]} />
                                </div>
                                <div class="btn-group mt-3 mb-4" role="group" aria-label="Basic outlined example">
                                    <button type="button" class="btn btn-outline-primary" onClick={() => setActiveData(data, loginData, setData)}>Logins</button>
                                    <button type="button" class="btn btn-outline-primary" onClick={() => setActiveData(data, companyViewData, setData)}>Company Views</button>
                                    <button type="button" class="btn btn-outline-primary" onClick={() => setActiveData(data, personViewData, setData)}>Resume Views</button>
                                    <button type="button" class="btn btn-outline-primary" onClick={() => setActiveData(data, lookupData, setData)}>Lookups</button>
                                    <button type="button" class="btn btn-outline-primary" onClick={() => setActiveData(data, emailData, setData)}>Emails Generated</button>
                                </div>
                                <div class="chart-grid">
                                    <div class="p-1 mb-5 chart">
                                        <Bar data={activeData} />
                                    </div>
                                    {/* <div class="p-1 mb-5 chart">
                                        <Bar data={lookupData} />
                                    </div> */}
                                </div>
                                <div class="col-12 mt-4 mb-1" id="small-table-wrapper">
                                    <table id="" class="table table-bordered sortable border-2 border-dark text-center">
                                        <thead class="stickyHeader">
                                            <tr class="table-success border-2 border-dark border-top-0">
                                                <th>ID</th>
                                                <th class="col-2" onClick={() => showFilterBox("UsernameFilter")}>Username
                                                    <div class="dropdown">
                                                        <div class="dropdown-content" style={{ display: "none" }} id={"UsernameFilter"}>
                                                            <div class="my-1 mx-1">
                                                                <input style={{ width: "250px" }} autocomplete="off" onKeyDown={(event) => adjustFilters(event, "Username", setData, data)} onClick={() => showFilterBox("UsernameFilter")} class="form-text form-control bg-light" id={"UsernameInput"}>
                                                                </input>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </th>
                                                <th onClick={() => showFilterBox("TypeFilter")}>Type
                                                    <div class="dropdown">
                                                        <div class="dropdown-content" style={{ display: "none" }} id={"TypeFilter"}>
                                                            <div class="my-1 mx-1">
                                                                <input style={{ width: "250px" }} autocomplete="off" onKeyDown={(event) => adjustFilters(event, "Type", setData, data)} onClick={() => showFilterBox("TypeFilter")} class="form-text form-control bg-light" id={"TypeInput"}>
                                                                </input>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </th>
                                                <th>Details</th>
                                                <th>Time</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {events.map((row) =>
                                                <tr>
                                                    <td>{row[0]}</td>
                                                    <td>{row[1]}</td>
                                                    <td>{row[2]}</td>
                                                    <td>{row[3].replaceAll("|", ", ")}</td>
                                                    <td class="col-3">{row[4]}</td>
                                                </tr>
                                            )}
                                        </tbody>
                                        <tfoot></tfoot>
                                    </table>
                                </div>
                            </>
                        )
                }
            </div>
            <div class="pb-5"></div>
        </div>
    )
}

export default UsageReport